
const LogosMarquee = ({ image, isReverse = false }: any) => {

    return (
        <div className="relative flex overflow-x-hidden">
            <div className={`flex flex-row ${isReverse ? 'animate-reverseMarquee' : 'animate-marquee'} whitespace-nowrap overflow-visible`}>

                {
                    Array.from({ length: 7 }, (_, i) => (
                        <img
                            className="h-[50px] md:h-full max-w-none object-contain"
                            src={image}
                            loading="lazy"
                            alt=""
                        />
                    ))
                }

            </div>
        </div>
    );
};

export default LogosMarquee;
